import { defineComponent as _defineComponent } from 'vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsAutocomplete from '@/components/vision/Inputs/VsAutocomplete/VsAutocomplete.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { useStore } from 'vuex-composition-helpers'
import { computed, ref, watch } from 'vue'
import { useCurrentOrg } from '@/common/useCurrentOrg'
import { useGetAssignableHubs } from '@/api/hubs'
import { useGetGuestConnectedOrganizationToThisOrganization } from '@/api/organizations'
import { useGetManagedCompaniesOptions } from '@/api/options'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationAccessAndOwnership',
  props: {
    location: null
  },
  emits: ["updated"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updated', data: { field: string; value: any }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  location: {
    ownerId?: string | null
    canEdit?: boolean | null
    private?: boolean | null
    accessBusinessUnitIds?: string[] | null
  }
}



const store = useStore()
const isHubUser = computed(
  () => store.getters['permissions/isHostOrganizationUser']
)
const isLocationOwnedByCurrentOrganizationToggle = ref(false)
const privateToggle = ref(!!props.location.private)
const { currentOrg } = useCurrentOrg()
const currentOrgId = computed(() => currentOrg.value?.id)

const disabled = computed(() => !props.location.canEdit)

const { data: locationHubOptions } = useGetAssignableHubs(currentOrgId)
const { data: locationOrganizationOptions } =
  useGetGuestConnectedOrganizationToThisOrganization(currentOrgId)

const availableInTheChosenClientLabel = computed(() => {
  const clientName = locationOrganizationOptions.value?.find(
    (o) => o.id === props.location.ownerId
  )?.name
  return `Available in ${clientName}`
})

const locationHubOptionsFilteredByOwnerId = computed(() =>
  locationHubOptions.value?.filter(
    (o) => o.organizationId === props.location.ownerId
  )
)

function onOwnerRadioChanged(e: boolean) {
  if (!e) {
    handleLocationUpdate({
      field: 'ownerId',
      value: currentOrg.value?.id,
    })
  } else {
    handleLocationUpdate({
      field: 'ownerId',
      value: null,
    })
  }
  handleLocationUpdate({
    field: 'private',
    value: false,
  })
  handleLocationUpdate({
    field: 'accessBusinessUnitIds',
    value: [],
  })
}

function onPrivateChanged(e: boolean) {
  handleLocationUpdate({
    field: 'private',
    value: e,
  })
}

function onClientChanged(e: string) {
  handleLocationUpdate({ field: 'ownerId', value: e })
  handleLocationUpdate({ field: 'accessBusinessUnitIds', value: [] })
}

watch(
  () => props.location.ownerId,
  (newVal) => {
    isLocationOwnedByCurrentOrganizationToggle.value =
      newVal !== currentOrg.value?.id
  },
  { immediate: true }
)
watch(
  () => props.location.private,
  (newVal) => {
    privateToggle.value = !!newVal
  },
  { immediate: true }
)


function handleLocationUpdate(data: { field: string; value: any }) {
  emit('updated', data)
}

const { data: managedCompanies } = useGetManagedCompaniesOptions()
watch(managedCompanies, (next) => {
  // once the companies list has loaded,
  // if there is only one company in the list
  // and there is no location owner,
  // set the location owner to the single company we have.

  if (
    props.location.ownerId === null &&
    next?.length === 1 &&
    'value' in next[0]
  ) {
    handleLocationUpdate({
      field: 'ownerId',
      value: next[0].value,
    })
  }
})

return { __sfc: true,props, store, isHubUser, isLocationOwnedByCurrentOrganizationToggle, privateToggle, currentOrg, currentOrgId, disabled, locationHubOptions, locationOrganizationOptions, availableInTheChosenClientLabel, locationHubOptionsFilteredByOwnerId, onOwnerRadioChanged, onPrivateChanged, onClientChanged, emit, handleLocationUpdate, managedCompanies, VsHeading, VsAutocomplete, VsWrapper }
}

})